import React from 'react'

const EntryList = ({ entry, onEdit, onDelete }) => { 
  // Input: A resource document
  // Output: An interactive summary of a resource in the Admin Dashboard.
return(
  <div className="entry" key={entry._id}>
    <h3>{entry.Name}</h3>
    <p className="services">Services: {entry.Services}</p>
    <p className="email">Email: {entry.Email}</p>
    <p className="address">Address: {entry.Address}</p>
    <div className="actions">
      <button className="edit" onClick={() => onEdit(entry)}>Edit</button>
      <button className="delete" onClick={() => onDelete(entry._id)}>Delete</button>
    </div>
  </div>
  );
};

export default EntryList;
